import React, { memo, useCallback, useMemo, useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import ListLinkButton from './LinkListButton'
import { BASE_BREAKPOINTS } from '../../../utils/enhancers/withResponsive'

const StyledList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  height: auto;
  overflow: hidden;

  li {
    box-sizing: content-box;
    display: flex;

    &:hover {
      background-color: ${props => props.theme.Colors.paleGreyLight};
    }

    &:not(:last-child) {
      border-bottom: 1px solid ${props => props.theme.Colors.silver};
    }

    a {
      display: flex;
      justify-content: space-between;
      width: 100%;
      line-height: 22px;
      height: fit-content;
      padding-top: 8px;
      padding-bottom: 8px;
      color: inherit;
      text-decoration: none;
      font-size: 16px;

      @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
        padding-top: 16px;
        padding-bottom: 16px;
      }
    }
  }

  ${props =>
    props.collapsed &&
    css`
      li:nth-child(n + ${props.maxLinks + 1}) {
        display: none;
      }
      li:nth-child(${props.maxLinks}) {
        a {
          opacity: 0.4;
        }
      }
    `}

  ${props =>
    !props.collapsed &&
    css`
      li:nth-child(n + 250) {
        display: none;
      }
    `}
`

const LinkList = ({ links, wording, maxLinks, baseCollapse }) => {
  const shouldCollapse = useMemo(() => links.length > maxLinks, [links])
  const [collapsed, setCollapsed] = useState(shouldCollapse)
  const toggleCollapse = useCallback(() => setCollapsed(c => !c), [])

  useEffect(
    () => {
      if (baseCollapse !== undefined) setCollapsed(baseCollapse)
    },
    [baseCollapse],
  )

  return (
    <div>
      <StyledList {...{ collapsed, maxLinks }}>
        {links.map(link => (
          <li key={links.indexOf(link)}>
            <a href={link.url}>
              <span>{link.text}</span>
              {link.count && <span>({link.count} annonces)</span>}
            </a>
          </li>
        ))}
      </StyledList>
      {shouldCollapse && baseCollapse === undefined && <ListLinkButton collapsed={collapsed} wording={wording} toggleCollapse={toggleCollapse} />}
    </div>
  )
}

export default memo(LinkList)
